module.exports = " <div class=vc-page> <header-bar> <icon-button slot=left @click=back() icon=arrow_back></icon-button> <span>Indicator</span> </header-bar> <scroll-view class=center-block> <button-area> <button text=\"点击弹出 indicator\" @click=showIndicator() raised></button> <button text=\"弹出 modal indicator\" @click=showModalIndicator() raised></button> <button text=控制透明度 @click=showOpactiyIndicator() raised></button> </button-area> </scroll-view> <indicator :show=indicator.show :type=indicator.type :text=indicator.text :overlay-opacity=indicator.opactiy></indicator> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-examples/views/indicator.vue
 ** module id = 396
 ** module chunks = 1
 **/